import React, { useEffect } from 'react';
import { ContentContainer } from '../ContentContainer';
import { ReviewSummary } from './components/ReviewSummary';
import { ReviewList } from './components/ReviewList';
import type { ReviewTabProps } from './types/ReviewTabProps';
import { Divider, Flex, VerticalSpacing } from '@banhala/ui-kit';

export const ReviewTab: React.FC<ReviewTabProps> = props => {
  const [summaryHeight, setSummaryHeight] = React.useState(0);
  const [listHeight, setListHeight] = React.useState(100);
  const [tabHeight, setTabHeight] = React.useState(0);

  useEffect(() => {
    const targetHeight = summaryHeight + listHeight;
    if (tabHeight !== targetHeight) {
      props.onChangeTabHeight(targetHeight);
      setTabHeight(targetHeight);
    }
  }, [summaryHeight, listHeight, tabHeight, props]);

  return (
    <ContentContainer focused={props.focused}>
      <Flex
        onLayout={({ nativeEvent }) => {
          setSummaryHeight(nativeEvent.layout.height);
        }}
      >
        <ReviewSummary />
        <Divider size={'medium'} />
      </Flex>
      <Flex
        onLayout={({ nativeEvent }) => {
          setListHeight(nativeEvent.layout.height);
        }}
      >
        <ReviewList />

        <VerticalSpacing size={36 + 20} />
      </Flex>
    </ContentContainer>
  );
  // return (
  //   <GoodsWebviewContent
  //     key={'REVIEW'}
  //     url={props.url}
  //     focused={props.focused}
  //     onChangeHeight={props.onChangeTabHeight}
  //   />
  // );
};
